import React from 'react';
import { jobStatusPathMap, getJobStatusColour } from './config';
import { JobStatuses } from 'common/state/jobs/actions';
import Icon from '@mdi/react';
import styled, { keyframes, useTheme } from 'styled-components';
import { IconProps } from '@mdi/react/dist/IconProps';

const spinKeyframes = keyframes`
  from { transform: rotate(0deg)}
  to   { transform: rotate(360deg)}
`;

const IconElement = styled(Icon)<{ status: JobStatuses }>`
  animation: 1s infinite
    ${({ status }) =>
      status === JobStatuses.STARTED ? spinKeyframes : undefined};
`;

export const StatusIcon = ({
  status,
  ...rest
}: { status: JobStatuses } & Omit<IconProps, 'path' | 'color'>) => {
  const theme = useTheme();
  return (
    <IconElement
      status={status}
      path={jobStatusPathMap[status]}
      color={getJobStatusColour(status, theme)}
      {...rest}
    />
  );
};
